export enum ProfileInformationModeEnum {
  EDIT = 'edit',
  VIEW = 'view',
}

export enum ProfilePhoneEmailEnum {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum RegionalAddressSearchTypeEnum {
  PROVINCE = 'provinces', // to remove after backend changes
  STATE = 'states',
  DISTRICT = 'districts',
  SUBDISTRICT = 'subdistricts',
  POSTALCODE = 'postalcodes',
}
